import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "button"]

  connect() {
    this.buttonTarget.disabled = true
  }

  validate() {
    this.buttonTarget.disabled = this.inputTarget.value !== "削除"
  }
}
